module.exports = __webpack_public_path__ + "static/img/storefront.fb0c1d5.png";


//////////////////
// WEBPACK FOOTER
// ./static/storefront.png
// module id = ZLmH
// module chunks = 1